// @ts-strict-ignore
import { Location } from '@dialogue/coredata'
import { SagaActionProps } from 'APP/Models/Actions'
import { call, put, select } from 'typed-redux-saga'

import { getPlacesApi } from '../utils/emergencyRoom'
import { GetPlacesRequest, placesActions } from './slice'
import Analytics from 'APP/Services/Analytics'
import { RootState } from 'APP/Store/CreateStore'

export const patientState = (state: RootState) => state.patient

export function* getPlaces({ payload }: SagaActionProps<GetPlacesRequest>) {
  try {
    const api = yield* call(getPlacesApi)
    const patient = yield* select(patientState)

    // If we have a place_id, fetch the coordinates.
    let location: Location
    if (typeof payload.origin === 'string') {
      const place = yield* call(api.getPlaceDetails, { placeId: payload.origin })
      location = place.data.data.coordinates
    } else {
      location = payload.origin
    }

    const response = yield* call(api.searchPlaces, {
      searchPlacesRequest: { ...payload, origin: location },
    })
    // Array of places (full data for each)
    const places = response.data?.data
    yield put(placesActions.getPlacesSuccess(places))

    yield call(Analytics.trackEvent, 'self_navigation_search_completed', {
      // @ts-expect-error untyped
      member_id: patient.profile.id,
      search_term: payload.query,
      coordinate: location,
    })
  } catch (e) {
    yield put(placesActions.getPlacesFailure({ error: e as Error }))
  }
}
